<div class="modal-header">
  <div class='row'>
    <div class='col'>
      <h3>Alterar Assinatura</h3>
      <i class="fas fa-times" (click)="fecharModal()"></i>
    </div>
  </div>
</div>
<div class="modal-body">
  <div class="container">
    <div class="">
      <div class="row">
        <div class="col-sm-6">
          <div id="signature-pad" class="signature-pad">
            <div class="signature-pad--body">
              <label><strong>Escreva</strong></label>
              <p style="border-width: 1px; border-style: solid; border-color: #181818;">
              <canvas #sPad width="555" height="200"></canvas>
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-6" *ngIf="usuario.AssinaturaDigitalizada != null">
          <label><strong>Assinatura</strong></label>
          <p style="border-width: 1px; border-style: solid; border-color: #181818;">
          <img src="{{Api}}{{usuario.AssinaturaDigitalizada}}" />
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" style="margin-top: 4px; text-align: end;">
            <button class="btn btn-success" (click)="salvarAssinatura()" type="submit">Registrar Assinatura</button>
            <button class="btn btn-success" (click)="limpar()" type="submit" style="margin-left: 1%;">Limpar</button>
        </div>
      </div>
    </div>
  </div>
</div>

